module.exports = __webpack_public_path__ + "static/media/TMT 1c.f6b2f9df.jpg";